import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Link from "@amzn/meridian/link";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const ActionableMetricView = (data) => {

    const onMetricCountClick = () => {
        if (data.onMetricCountClick) {
            data.onMetricCountClick();
        }
    }
    const {isMobile} = useDeviceLayout()
    const headerFont = isMobile ? "b100" : "h100"

    return (
        <Column spacing="small">
            <Text type={headerFont}>
                <b><FormattedMessage id={data.stageStatus.title} defaultMessage={data.stageStatus.message}/></b>
            </Text>
            <Text type="d50">
                <Link type={"secondary"} onClick={onMetricCountClick}>{data.stageStatus.value}</Link>
            </Text>
        </Column>
    )
}

export default ActionableMetricView


// WEBPACK FOOTER //
// ./src/components/stageStatus/ActionableMetricView.js